// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add custom styling for headings */
.article-content h1, .article-content h2, .article-content h3 {
    font-weight: bold;
    font-family: 'poppins', sans-serif; 
    margin-bottom: 10px;
  }
  
  .article-content h1 {
    font-size: 2em; /* or use your desired size */
  }
  
  .article-content h2 {
    font-size: 1.5em; /* or use your desired size */
  }
  
  .article-content h3 {
    font-size: 1.2em; /* or use your desired size */
  }
  
  /* Style unordered list */
  .article-content ul {
    list-style-type: disc;
    padding-left: 20px;
  }
  
  .article-content ol {
    list-style-type: decimal;
    padding-left: 20px;
  }
  
  /* Style list items */
  .article-content li {
    margin-bottom: 5px;
  }
  
  /* Ensure links are styled properly */
  .article-content a {
    color: blue;
    text-decoration: underline;
  }
  
  .article-content a:hover {
    color: darkblue;
  }

  .article-content p {
    font-family: 'poppins', sans-serif; 
    font-size: 1.1em;
    line-height: 1.9;
    color: rgb(209 213 219);
}


  /* Ensure text alignment works for Quill's HTML output */
.article-content .ql-align-center {
    text-align: center;
  }
  
  .article-content .ql-align-right {
    text-align: right;
  }
  
  .article-content .ql-align-left {
    text-align: left;
  }
  
  /* Additional styles for lists if needed */
  .article-content ul, .article-content ol {
    padding-left: 20px;
  }
  
  `, "",{"version":3,"sources":["webpack://./src/styles/article-content.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;IACI,iBAAiB;IACjB,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,cAAc,EAAE,6BAA6B;EAC/C;;EAEA;IACE,gBAAgB,EAAE,6BAA6B;EACjD;;EAEA;IACE,gBAAgB,EAAE,6BAA6B;EACjD;;EAEA,yBAAyB;EACzB;IACE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA,qBAAqB;EACrB;IACE,kBAAkB;EACpB;;EAEA,qCAAqC;EACrC;IACE,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;;EAGE,wDAAwD;AAC1D;IACI,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,0CAA0C;EAC1C;IACE,kBAAkB;EACpB","sourcesContent":["/* Add custom styling for headings */\n.article-content h1, .article-content h2, .article-content h3 {\n    font-weight: bold;\n    font-family: 'poppins', sans-serif; \n    margin-bottom: 10px;\n  }\n  \n  .article-content h1 {\n    font-size: 2em; /* or use your desired size */\n  }\n  \n  .article-content h2 {\n    font-size: 1.5em; /* or use your desired size */\n  }\n  \n  .article-content h3 {\n    font-size: 1.2em; /* or use your desired size */\n  }\n  \n  /* Style unordered list */\n  .article-content ul {\n    list-style-type: disc;\n    padding-left: 20px;\n  }\n  \n  .article-content ol {\n    list-style-type: decimal;\n    padding-left: 20px;\n  }\n  \n  /* Style list items */\n  .article-content li {\n    margin-bottom: 5px;\n  }\n  \n  /* Ensure links are styled properly */\n  .article-content a {\n    color: blue;\n    text-decoration: underline;\n  }\n  \n  .article-content a:hover {\n    color: darkblue;\n  }\n\n  .article-content p {\n    font-family: 'poppins', sans-serif; \n    font-size: 1.1em;\n    line-height: 1.9;\n    color: rgb(209 213 219);\n}\n\n\n  /* Ensure text alignment works for Quill's HTML output */\n.article-content .ql-align-center {\n    text-align: center;\n  }\n  \n  .article-content .ql-align-right {\n    text-align: right;\n  }\n  \n  .article-content .ql-align-left {\n    text-align: left;\n  }\n  \n  /* Additional styles for lists if needed */\n  .article-content ul, .article-content ol {\n    padding-left: 20px;\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
